<template>
  <modal
    :title="$t(title)"
    :appendToBody="true"
    :top="'12vh'"
    :visible.sync="isShowDialog"
  >
    <div class="configNetPage">
      <!-- 基本信息 -->
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template
              v-if="item.key === 'config_status' || item.key === 'device_type'"
            >
              <span>{{ changeTextFn(item.key, cmdObj[item.key]) }}</span>
            </template>
            <template v-else-if="item.key === 'step'">
              <span
                v-show="
                  cmdObj[item.key] && typeof cmdObj[item.key] === 'string'
                "
              >
                <span>{{ stepFn(cmdObj[item.key]) }}</span>
              </span>
            </template>
            <template v-else-if="item.isBool">
              <span v-if="cmdObj['config_status'] !== 2">{{
                objFn1(cmdObj[item.key])
              }}</span>
              <span style="color:red">{{ objFn2(cmdObj[item.key]) }}</span>
            </template>
            <span v-else> {{ cmdObj[item.key] }}</span>
          </span>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
import { configStep, magnetismType, configStatusConvert } from '@/utils/convert'

export default {
  props: {
    title: { type: String, default: '' },
    isShow: { type: Boolean, default: false },
    cmdObj: { type: Object, default: () => ({}) },
    sensorWay: { type: String, default: '' }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  watch: {
    cmdObj (newVal) {
      this.baseMsg = [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'magnetism_code',
          text: 'integration.magnetism_code'
        },
        {
          key: 'config_status',
          text: 'device.config_status'
        },
        {
          key: 'carrierName',
          text: 'public.carrier'
        },
        {
          key: 'device_type',
          text: 'integration.gas_type'
        },
        {
          key: 'description',
          text: 'public.table_desc'
        }
      ]
      // 去除监测点
      if (
        this.$attrs.sensorWay === 'unknown' ||
        this.$attrs.sensorWay === 'unbind'
      ) {
        this.baseMsg.splice(3, 1)
      }
      if (newVal.config_status === '') {
        this.baseMsg = this.baseMsg.filter(item => item.key !== 'config_status')
      }
      const publicArray = [
        {
          key: 'cmd',
          text: 'public.command'
        },
        {
          key: 'step',
          text: 'integration.configuration_steps'
        }
      ]
      if (newVal.type === 'app') {
        this.baseMsg.push(
            {
              key: 'collectInterval',
              text: 'device.sample_interval',
              isBool: true
            },
            {
              key: 'alarm_threshold',
              text: 'integration.alarm_threshold',
              isBool: true
            },
          ...publicArray
        )
      }
    }
  },
  data () {
    return {
      baseMsg: []
    }
  },
  methods: {
    changeTextFn (key, value) {
      if (key === 'device_type') {
        return magnetismType[value] && this.$t(magnetismType[value].title)
      } else {
        // return value === 0
        //   ? $t('device.wait_config')
        //   : value === 1
        //     ? $t('device.configured')
        //     : $t('device.configured')
        return this.$t(configStatusConvert(value).title)
      }
    },
    objFn1 (obj) {
      return obj ? obj.current + '-->' : ''
    },
    objFn2 (obj) {
      return obj ? obj.modify : ''
    },
    stepFn (value) {
      return configStep[value] && this.$t(configStep[value].title)
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;
    padding: 10px 20px;
    max-height: 500px;
    overflow: auto;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 32px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 32px;
      color: #606266;
      font-size: 14px;
      text-align: left;
    }
  }
}
</style>
